import { render, staticRenderFns } from "./ThemeToggle.vue?vue&type=template&id=4dc13ae8"
import script from "./ThemeToggle.vue?vue&type=script&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc13ae8')) {
      api.createRecord('4dc13ae8', component.options)
    } else {
      api.reload('4dc13ae8', component.options)
    }
    module.hot.accept("./ThemeToggle.vue?vue&type=template&id=4dc13ae8", function () {
      api.rerender('4dc13ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/accessibility/ThemeToggle.vue"
export default component.exports